import React, { useState,useEffect } from 'react';
import { Form, Input, ConfigProvider, Button, Space, Spin, message, Tabs, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { hnrequest } from '@/utils'

// import Highlighter from 'react-highlight-words';
import './index.scss'
import zhCN from 'antd/locale/zh_CN';





const Dbanybz = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [fdbsc] = Form.useForm();

  const [spinning, setSpinning] = useState(false);


  useEffect(() => {
    function getau() {
      fdbsc.setFieldsValue({ "date_t": "生产日期", "batch_t": "生产批次" });

    }
    getau()


  }, [fdbsc])


  const beforeUpload = (file) => {
    if (!file.name.endsWith('.txt')) {
      message.error('只能上传 .txt 文件');
      return Upload.LIST_IGNORE;
    }

    const reader = new FileReader();
    reader.readAsText(file, 'UTF-8');

    reader.onload = (e) => {
      const text = e.target.result;

      // 1. 按行 / 逗号 / 空格拆分
      const urls = text
        .split(/[\n,，\s]+/)
        .map(url => url.trim())
        .filter(url => url.length > 0)
        .map(url => {
          // 2. 去掉引号
          url = url.replace(/^["']+|["']+$/g, '');

          // 3. 只保留合法追溯 URL
          if (/^https?:\/\//.test(url)) {
            return url;
          }
          return null;
        })
        .filter(Boolean);

      // login(urls);
      fdbsc.setFieldsValue({ 'code_urls': urls });
      fdbsc.submit();

      // console.log('解析后的 code_urls：', urls);

    };

    reader.onerror = () => {
      message.error('文件读取失败');
    };

    return false; // 阻止 antd 自动上传
  };

  // 

  const onFinish_dbsc = async (props) => {
    setSpinning(true)
    const pad = await hnrequest.post('/p_a_updb_date_batchs', props)
    pad.return_code === "error" && messageApi.open({ type: pad.return_code, content: pad.return_msg, });
    pad.return_code === "success" && messageApi.open({ type: pad.return_code, content: pad.return_msg, });
    setSpinning(false)

  };


  // 
  const itemss = [
    {
      key: '1',
      label: '数据上传',
      children: <>

        <Form
          name="fdbsc"
          form={fdbsc}
          layout="vertical"
          onFinish={onFinish_dbsc}
          className='nypd'
        >
          <Form.Item
            hidden
            name="code_urls"
          >
            <Input />
          </Form.Item>
          <Space size="medium">
            <Space.Compact>
              <Form.Item
                // hidden
                name="date_t"
                rules={[
                  {
                    required: true,
                    message: '生产日期 标题',
                  },
                ]}
              ><Input placeholder='生产日期 标题' /></Form.Item>

              <Form.Item
                // hidden
                name="pdate"
                rules={[
                  {
                    required: true,
                    message: '请输入 生产日期',
                  },
                ]}
              ><Input placeholder='生产日期' /></Form.Item>
            </Space.Compact>


            <Space.Compact>
              <Form.Item
                // hidden
                name="batch_t"
                rules={[
                  {
                    required: true,
                    message: '请输入 生产批次/批号 标题',
                  },
                ]}
              ><Input placeholder='生产批次/批号 标题' /></Form.Item>

              <Form.Item
                // hidden
                name="batch_no"
                rules={[
                  {
                    required: true,
                    message: '请输入 生产批次/批号',
                  },
                ]}
              ><Input placeholder='生产批次/批号' /></Form.Item>
            </Space.Compact>
          </Space>
        </Form>


        <Upload
          accept=".txt,text/plain"
          showUploadList={false}
          beforeUpload={beforeUpload}
          maxCount={1}
        >
          <Button icon={<UploadOutlined />}>上传 txt 文件</Button>
        </Upload>



      </>,
    },
    {
      key: '2',
      label: '区间标注',
      children: '正在内测中...',
    },
    {
      key: '3',
      label: '生产同步记录',
      children: '正在内测中...',
    },
  ];




  return (
    <>


      <ConfigProvider locale={zhCN} >
        {contextHolder}

        <Tabs defaultActiveKey="1" items={itemss} />







        {/*  */}

        <Spin spinning={spinning} description="数据整理中，请稍等..." fullscreen />

      </ConfigProvider>
    </>

  );
};
export default Dbanybz;